import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import Logo from '../Logo';

const NAV = [
  { id: 'overview',  icon: '◉', label: 'Overview'       },
  { id: 'sessions',  icon: '▤',  label: 'Sessions'       },
  { id: 'devices',   icon: '⊞',  label: 'Kiosk Devices'  },
];

export default function Sidebar({ activeTab, onTabChange }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <aside style={s.sidebar}>
      {/* Brand */}
      <div style={s.brand}>
        <span style={s.brandIcon}><Logo size={30} /></span>
        <div>
          <div style={s.brandName}>Picklers Lounge</div>
          <div style={s.brandSub}>Admin</div>
        </div>
      </div>

      {/* Nav */}
      <nav style={s.nav}>
        {NAV.map(item => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            style={{
              ...s.navItem,
              ...(activeTab === item.id ? s.navItemActive : {}),
            }}
          >
            <span style={s.navIcon}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div style={s.footer}>
        <div style={s.userRow}>
          <div style={s.avatar}>
            {(auth?.user_info?.username || 'A')[0].toUpperCase()}
          </div>
          <div style={s.userInfo}>
            <div style={s.userName}>{auth?.user_info?.username || 'Admin'}</div>
            <div style={s.userRole}>Administrator</div>
          </div>
        </div>
        <button onClick={handleLogout} style={s.logoutBtn} title="Sign out">
          ⎋
        </button>
      </div>
    </aside>
  );
}

const s = {
  sidebar: {
    width: 'var(--sidebar-width)', minHeight: '100vh',
    background: 'var(--white)',
    borderRight: '1px solid var(--gray-200)',
    display: 'flex', flexDirection: 'column',
    position: 'fixed', top: 0, left: 0, bottom: 0,
    zIndex: 40,
  },
  brand: {
    padding: '24px 20px 20px',
    display: 'flex', alignItems: 'center', gap: 10,
    borderBottom: '1px solid var(--gray-100)',
    marginBottom: 8,
  },
  brandIcon: { fontSize: 26 },
  brandName: { fontSize: 16, fontWeight: 700, color: 'var(--gray-900)', lineHeight: 1.2 },
  brandSub: { fontSize: 11, color: 'var(--gray-400)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.06em' },
  nav: { flex: 1, padding: '8px 10px', display: 'flex', flexDirection: 'column', gap: 2 },
  navItem: {
    width: '100%', padding: '10px 12px',
    display: 'flex', alignItems: 'center', gap: 10,
    border: 'none', background: 'none',
    borderRadius: 'var(--radius-sm)',
    fontSize: 14, fontWeight: 500, color: 'var(--gray-600)',
    cursor: 'pointer', textAlign: 'left',
    transition: 'background 0.15s, color 0.15s',
    fontFamily: 'var(--font)',
  },
  navItemActive: {
    background: 'var(--blue-light)',
    color: 'var(--blue)', fontWeight: 600,
  },
  navIcon: { fontSize: 16, width: 20, textAlign: 'center', flexShrink: 0 },
  footer: {
    padding: '14px 14px',
    borderTop: '1px solid var(--gray-100)',
    display: 'flex', alignItems: 'center', gap: 10,
  },
  userRow: { flex: 1, display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 },
  avatar: {
    width: 32, height: 32, borderRadius: '50%',
    background: 'var(--blue)', color: 'white',
    fontSize: 13, fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
  },
  userInfo: { minWidth: 0 },
  userName: {
    fontSize: 13, fontWeight: 600, color: 'var(--gray-900)',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  userRole: { fontSize: 11, color: 'var(--gray-400)' },
  logoutBtn: {
    width: 32, height: 32, borderRadius: 'var(--radius-sm)',
    border: '1px solid var(--gray-200)',
    background: 'none', color: 'var(--gray-500)',
    fontSize: 16, cursor: 'pointer', flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
};
